import { render, staticRenderFns } from "./product-details.component.vue?vue&type=template&id=07b9300c&scoped=true"
import script from "./product-details.component.vue?vue&type=script&lang=ts"
export * from "./product-details.component.vue?vue&type=script&lang=ts"
import style0 from "./product-details.component.vue?vue&type=style&index=0&id=07b9300c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b9300c",
  null
  
)

export default component.exports